import script from "./BIK-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./BIK-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./BIK-Questionnaire-Main.vue?vue&type=style&index=0&id=5fc9940a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc9940a"]])

export default __exports__